
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Your gateway to the European Union`}</h2>
    <Paragraph size="lead" mdxType="Paragraph">
  As the Gateway to the European Union, europa.eu provides up-to-date,
  consistent and relevant information on the over-arching aims and objectives of
  the European Union, its membership, operational structure, services and key
  actions.
    </Paragraph>
    <Paragraph size="lead" mdxType="Paragraph">
  The information is structured and displayed to facilitate easy interaction,
  and build onward engagement through clear connections to further relevant
  content wherever it may lie throughout the EU digital ecosystem.
    </Paragraph>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;